import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import { get } from 'lodash';
import { findResultByEvent, wildcardFilter } from '@/utils/resultsHelper';
import selectors from '@/selectors';
import callAdapter from '@/utils/sagaHelper';
import NotificationsService from '../service';
import { showNotifications, showNotificationsError } from '../actions';
import actions from '../constants';

export function* notifications(action) {
  const notes = yield select(selectors.notifications);
  const { filter, pageSize, currentPage } = findResultByEvent(notes, action, action.event);
  const page = action.page || currentPage;
  const size = action.pageSize || pageSize;
  const { response, error } = yield call(callAdapter, NotificationsService.notifications(
    action.category,
    action.code,
    action.event,
    wildcardFilter(filter),
    page,
    size,
  ));

  if (error) {
    yield put(showNotificationsError(action.category, action.code, action.event, error));
  } else {
    yield put(showNotifications(
      action.category,
      action.code,
      action.event,
      get(response.additional, `${action.category}.name`, ''),
      action.append,
      size,
      response.items,
      response.paging.total,
      response.paging.pages,
      response.paging.page,
    ));
  }
}

export default function* notificationsApi() {
  yield takeEvery([actions.FETCH_NOTIFICATIONS, actions.REFRESH_NOTIFICATIONS], notifications);
}
